import Store from '../redux/store/index';
import { setLogged } from '../redux/actions/index';
/**
 * uo = jwt salt
 */

const loginSuccess = (tkn) => {
    //SAVE TOKEN IN SESSION STORAGE
    sessionStorage.setItem('uo', tkn)

    //SAVE DECODED DATA IN SESSION
    const data = decodeToken(tkn);
    // sessionStorage.setItem('loggedUid', data.uid);
    sessionStorage.setItem('loggedUser', data.name);

    Store.dispatch(setLogged({bool: true,uid:data.uid, name: data.name}))
}

function decodeToken(tkn){
    const base64Url = tkn.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
}

//CLEAR LOGIN INFO & REDIRECT TO LOGIN PAGE
const logout = (history) => {
    clearLog();
    // window.location = '/vaibhav';
    history.replace('/');
}

//ONLY CLEARS LOGIN, NO REDIRECT
const clearLog = () => {
    sessionStorage.removeItem('uo');
    sessionStorage.removeItem('loggedUser');

    Store.dispatch(setLogged({bool: false, uname: null}));
}

const getLoggedInfo = () => {
    const st = Store.getState();
    return {
        name: st.loggedUname,
        // roleNm: st.roleNm
    }
}
const Auth = {
    loginSuccess,
    logout,
    clearLog,
    // getUserRole,
    getLoggedInfo
}

export default Auth;